import actionTypes from './actionTypes';

export const fetchCurrentLocation = () => ({
  type: actionTypes.FETCH_CURRENT_LOCATION,
});

export const fetchedCurrentLocation = (payload) => ({
  type: actionTypes.FETCHED_CURRENT_LOCATION,
  payload,
});
